import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import { LogoutService } from './logout.service';
import { Router } from '@angular/router';
import { constants } from '../constants';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(public LANG: CommonUtilitiesService, private logoutService: LogoutService, private _router: Router) { }
  isBtnDisabled = false;
  ngOnInit() {
  }

  
  /**
   * Description: Método que finaliza la sesión activa de un usuario
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  logout(){

    //se obtiene la infor de sesión
    let userData = JSON.parse(localStorage.getItem("userData"));

    this.isBtnDisabled = true;
    this.logoutService.logOut(userData.documentId, userData.token).subscribe((data => {
      //habilitar botones
      this.isBtnDisabled = false;
      localStorage.clear();
      this._router.navigate([constants.ROUTE_URL_LOGIN]);
    }),
    (err) => {
      localStorage.clear();
      this._router.navigate([constants.ROUTE_URL_LOGIN]);
    });    
  }

}
